export default __webpack_public_path__ + "assets/boldly_go.8120549c.png";